import { render, staticRenderFns } from "./studentInfo.vue?vue&type=template&id=6ba2c731&scoped=true&"
import script from "./studentInfo.vue?vue&type=script&lang=js&"
export * from "./studentInfo.vue?vue&type=script&lang=js&"
import style0 from "./studentInfo.vue?vue&type=style&index=0&id=6ba2c731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba2c731",
  null
  
)

export default component.exports